import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { EmphasisLines } from '../EmphasisLines';
import { lastQuestion } from '../../data/salesContent';
export function LastQuestionSection() {
  return <PageSection labelledBy="last-question-title" data-id="element-118" data-mp="b9rutayomnpj">
      <SectionHeading id="last-question-title" title="Una última pregunta" data-id="element-119" data-mp="69dl7ohfn5pe" />
      <div className="mx-auto mt-6 max-w-xl space-y-1 text-center text-base italic leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-120" data-mp="26qopa9tgwlv">
        {lastQuestion.moments.map(m => <p key={m} data-id="element-121" data-mp="3tkd9ovuf6q2f">{m}</p>)}
      </div>
      <p className="mx-auto mt-6 max-w-xl text-center font-display text-3xl font-extrabold uppercase leading-tight tracking-wide text-accent-400 md:text-4xl" data-id="element-122" data-mp="3omboa49iuens">
        {lastQuestion.question}
      </p>
      <div className="mx-auto mt-5 max-w-xl space-y-1 text-center text-base leading-relaxed text-carbon-300 md:text-[17px]" data-id="element-123" data-mp="3eo5mrnrmnajg">
        {lastQuestion.paragraphs.map(p => <p key={p} data-id="element-124" data-mp="3anlq0layu8xu">{p}</p>)}
      </div>
      <EmphasisLines lines={lastQuestion.closing} className="mt-8" data-id="element-125" data-mp="33ab8ydif2n8s" />
    </PageSection>;
}